import React from 'react'
import { Link } from 'react-router-dom'
const { PUBLIC_URL } = process.env

const HomeCategoriesBanner = ({ activeCategory, bannerButtonText, selectCategory }) => {
  return (
    <div
      className="dealmed-home-categories__banner"
      style={{ backgroundImage: `url(${PUBLIC_URL}${activeCategory.bannerImage.fields.file.url})` }}
    >
      <div className="dealmed-container">
        <div className="dealmed-home-categories__banner-content">
          <h2 className="dealmed-home-categories__category">{activeCategory.categoryTitle}</h2>
          <p className="dealmed-home-categories__text">{activeCategory.categoryText}</p>
          {activeCategory ? (
            <Link
              onClick={() => selectCategory(activeCategory?.categoryData)}
              to={{
                pathname: `/category/${activeCategory?.categoryData?.urlComponent}`,
              }}
              className="dealmed-home-categories__link"
            >
              {bannerButtonText}
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default HomeCategoriesBanner
